import Vue from 'vue';
import {Column, Task, Task as TaskModel} from '@/interfaces/TaskInterfaces';
import TaskColumnMixin from '@/mixins/TaskColumnMixin';

const TODAYS_TASKS_ID = Column.TODAY;
const INCOMING_TASKS_ID = Column.INCOMING;
const UNREAD_TASKS_ID = -1;

export default Vue.component('right-panel-task-column', {
  name: 'RightPanelTaskColumn',
  mixins: [TaskColumnMixin],
  data() {
    return {
      tabs: [] as any,
      focusedTab: TODAYS_TASKS_ID,
      unreadTasks: [] as TaskModel[]
    }
  },
  created() {
    (this as any).tabs = [
      {
        id: TODAYS_TASKS_ID,
        name: 'Today',
        isFocused: (this).focusedTab === TODAYS_TASKS_ID,
        visible: true,
        tasks: [],
      },
      {
        id: INCOMING_TASKS_ID,
        name: 'Incoming',
        isFocused: (this).focusedTab === INCOMING_TASKS_ID,
        visible: true,
        tasks: []
      },
      {
        id: UNREAD_TASKS_ID,
        name: 'Unread',
        isFocused: (this).focusedTab === UNREAD_TASKS_ID,
        visible: true,
        tasks: []
      },
    ];
    this.setRightPanelTasks((this as any).tasks);
  },
  methods: {
    setTasks(newTasks: TaskModel[]) {
      // When the Mixin calls this, tabs have not yet been created so we do nothing.
      // Our created() will call our unique tasks
      // When watchers fire, tabs have been created so we need to pass along the task set
      if (this.tabs.length > 0) {
        this.setRightPanelTasks(newTasks);
      }
    },
    setRightPanelTasks(newTasks: TaskModel[]) {
      (this as any).loadEditingTasksState(newTasks);
      const map = new Map<number, any>();
      for (const tab of (this as any).tabs) {
        tab.tasks = [];
        map.set(tab.id, tab);
      }
      // Need to make sure we work with a copy or Vuex gets angry we're making changes without it.
      (this as any).ourTasks = newTasks.map((task: TaskModel) => {
        const oldTask = (this as any).ourTasks.find((oldTask: TaskModel) => oldTask.id === task.id);
        const toReturn = Object.assign({}, task);
        toReturn.isEditing = oldTask ? oldTask.isEditing : task.isEditing;
        if (map.get(Number(task.taskColumnId))){
          if (task.assignedToAppUserId === this.$store.state.user.appUserId && !task.isComplete) {
            map.get(Number(task.taskColumnId)).tasks.push(toReturn);
          }
        }
        const index = this.unreadTasks.findIndex(unreadTask => unreadTask.id === task.id);
        // we want to replace any task that was already in the list with a socket updated task to reflect any
        // changes.  Even if that means marking it as read.
        if (index >= 0) {
          this.unreadTasks.splice(index, 1, task);
        } else {
          if (!task.isRead) {
            this.unreadTasks.push(task);
          }
        }

        return toReturn;
      });
      map.get(UNREAD_TASKS_ID).tasks.push(...this.unreadTasks);
      this.tabs.forEach( (tab: any) => {
        tab.unreadCount = tab.tasks.filter((task: TaskModel) => !task.isRead).length;
      });
    },
    hasEmergencyTask(tab: any) {
      return tab.tasks.some((task: Task) => task.isEmergency);
    },
    async toggleEdit(task: TaskModel) {
      task.isEditing = !task.isEditing;
      // Hack to get it to go
      (this as any).ourTasks = (this as any).ourTasks.map((task: any) => task);
      if (!task.isRead && task.assignedToAppUserId === this.$store.state.user.appUserId) {
        await (this as any).markRead(task);
      }
      (this as any).storeEditingTaskState(task);
    },
    focusOnTab(tab: any) {
      if (tab.id === UNREAD_TASKS_ID) {
        this.unreadTasks = this.unreadTasks.filter((task) => {
          return !task.isRead;
        });
      }

      for (const aTab of (this as any).tabs) {
        aTab.isFocused = false;
        if (aTab.id === UNREAD_TASKS_ID) {
          aTab.tasks = Array.from(this.unreadTasks);
        }
      }
      tab.isFocused = true;
    },
    getTasksForReorder() : TaskModel[] {
      return this.tabs.filter((tab : any) => tab.isFocused)[0].tasks;
    }
  }
});



// WEBPACK FOOTER //
// ./src/componentsReusable/tasks/column/RightPanelTaskColumn.ts